<template>
  <div class="page-title d-flex flex-column flex-sm-row justify-space-between mb-6">
    <div class="d-flex align-center">
      <v-btn
        class="no-print"
        icon="fa-regular fa-arrow-left"
        color="transparent"
        elevation="0"
        @click="handleBack"
      />
      <div class="text-h5 text-sm-h4 font-weight-bold">
        {{ title }}
      </div>
      <v-tooltip v-if="tooltip !== undefined" :text="tooltip">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            color="transparent"
            class="ms-4"
            size="x-small"
          >
            <v-icon icon="fas fa-question" color="black" />
          </v-btn>
        </template>
      </v-tooltip>
    </div>
    <div class="d-flex justify-end ga-3 px-3">
      <slot name="prepend-custom-action" />
      <v-btn
        v-if="onReport !== undefined"
        v-tooltip="'Gerar Relatório'"
        icon="fa-regular fa-file-csv"
        color="primary"
        :loading="$loader.loading"
        @click="onReport()"
      />
      <v-btn
        v-if="onAdd !== undefined"
        v-tooltip="'Criar'"
        icon="fa-regular fa-plus"
        color="primary"
        :loading="$loader.loading"
        @click="onAdd()"
      />
      <v-btn
        v-if="onPrint !== undefined"
        v-tooltip="'Imprimir'"
        icon="fa-regular fa-print"
        color="primary"
        class="no-print"
        :loading="$loader.loading"
        @click="onPrint()"
      />
      <slot name="append-custom-action" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'

interface Props {
  title: string
  tooltip?: string
  onBack?: () => unknown
  onAdd?: () => unknown
  onReport?: () => unknown
  onPrint?: () => unknown
}

const router = useRouter()
const handleBack = () => {
  if (onBack) {
    onBack()
  } else {
    router.back()
  }
}

const { title, onAdd, onReport, onPrint, onBack } = defineProps<Props>()
</script>
